import { render, staticRenderFns } from "./StoreSwitcher.vue?vue&type=template&id=d8ef8c7c&scoped=true&"
import script from "./StoreSwitcher.vue?vue&type=script&lang=ts&"
export * from "./StoreSwitcher.vue?vue&type=script&lang=ts&"
import style0 from "./StoreSwitcher.vue?vue&type=style&index=0&id=d8ef8c7c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8ef8c7c",
  null
  
)

export default component.exports